import React from 'react'
import { Suspense, useEffect, useState } from 'react'
import {
    Await,
    defer,
    Link,
    useLoaderData,
    useNavigate
} from 'react-router-dom'
import { education, citizenshipEducation } from '../util/api'
import { Title } from './helper/DocumentTitle'
import LoadingSpinner from './components/LoadingSpinner'
import styles from '../styles/module/CitizenshipEducation.module.scss'
import Video from './helper/Video'

export const loader = async () => {
    return defer({ education: education(), citizenshipEducation: citizenshipEducation() })
}

export default function CitizenshipEducation() {
    const [loaderData, setLoaderData] = useState(useLoaderData())
    const [error, setError] = useState()
    const [isLoading, setIsLoading] = useState(false)

    const pageName = 'آموزش شهروندی'
    Title(pageName)
const navigate = useNavigate()

    const filterCourse = (e, id) => {
        // document.querySelectorAll('.filter__active').forEach(el => el.classList.remove('filter__active'))
        // e.target.classList.add('filter__active')
        // setData()
        // window.setTimeout(() => {
        //     if (id === 'all') setData(data)
        //     else setData(data.filter((item) => item.id === id))
        // }, 100)

    }
    useEffect(() => {
       document.querySelector('header span').innerText = pageName

        // var requestOptions = {
        //     method: 'GET',
        //     redirect: 'follow'
        // };

        // fetch(`${process.env.REACT_APP_BASE_URL}citizenshipEducation`, requestOptions)
        //     .then(response => response.json())
        //     .then(result => {
        //         setData(result)
        //         setCourse(result)
        //     })
        //     // .finally(() => document.querySelector('.course .shimmer').classList.remove('shimmer')
        //     // )
        //     .catch(error => console.log('error', error));

        // // Cleanup function
        // return () => {
        //     //  controller.abort();
        // }
    }, [])

    return <section className={styles.citizenshipEducation}>
        <div className='__frame' data-width={`large`}>
        <Link to={`../`} className='btn btn-back-top'>بازگشت</Link>


            <Suspense fallback={<LoadingSpinner />}>
                <Await
                    resolve={loaderData.education}
                    errorElement={<>error</>}>
                    {(data) => {
                        console.log(data)
                        return <ul className={styles.category}>
                            <li onClick={(e) => filterCourse(e, 0)}>
                                همه
                            </li>
                            {
                                data.map((item, i) => {
                                    return (
                                        <li key={i} onClick={(e) => filterCourse(e, item.id)}>
                                            {item.name}({item.citizenshipEducationVideoCount})
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    }}
                </Await>
            </Suspense>

            <div className={`${styles.playerWrapper}`}>
            <div className=''>
                    <div className={styles.videoWrapper}>
                        <Suspense fallback={<LoadingSpinner />}>
                            <Await
                                resolve={loaderData.citizenshipEducation}
                                errorElement={<>err3or</>}>
                                {(data) => {
                                    return (
                                        <Video options={{
                                            autoplay: false,
                                            controls: true,
                                            responsive: true,
                                            fluid: true,
                                            poster: `${process.env.REACT_APP_UPLOAD}images/${data[data.length - 1].poster}`,
                                            sources: [{ src: `${process.env.REACT_APP_UPLOAD}video/${data[data.length - 1].url}`, type: 'video/webm' }]
                                        }} />
                                    )
                                }}
                            </Await>
                        </Suspense>
                    </div>
                </div>
                <div className=''>
                    <div className='grid grid--fill grid--gap-1' style={{ '--data-width': '300px' }}>
                        <div className='card'>
                            <div className='card__header'>
                                ویدیوهای آموزش شهروندی
                            </div>
                            <div className='card__body'>
                                <Suspense fallback={<LoadingSpinner />}>
                                    <Await
                                        resolve={loaderData.citizenshipEducation}
                                        errorElement={<>error</>}>
                                        {(data) => {
                                            return (
                                                data.map((item, i) =>
                                                    <div className={styles.videoCard} key={i} onClick={() => {
                                                        document.querySelector('video').src = `${process.env.REACT_APP_UPLOAD}video/${item.url}`
                                                        document.querySelector('video').play()
                                                    }}>
                                                        <figure>
                                                            <img src={`${process.env.REACT_APP_UPLOAD}images/${item.poster}`} />
                                                        </figure>
                                                        <div>
                                                            <span> {item.title}</span>
                                                            <span>#{item.caategory_name}</span>
                                                        </div>
                                                    </div>
                                                )
                                            )
                                        }}
                                    </Await>
                                </Suspense>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Link to={`../`} className='btn btn-back-bottom'>بازگشت</Link>
    </section>
}